import {
    useGetDMaxCommon,
    type AboutDmaxInfoResponse,
    type AroundDmaxInfoResponse,
    type Aside1DmaxInfoResponse,
    type Aside2DmaxInfoResponse,
    type MainInfoDmaxResponse,
    type RoomDMaxInfoResponse,
    type SpecialDmaxInfoResponse,
    type VideoDmaxInfoResponse,
} from "@/shared/server";
import { Center, Flex, Spinner, Text } from "@chakra-ui/react";
import { AboutSection, Aside2Section, RoomPreview, SpecialPreview, TopSection, Travel } from "../common";
import { Aside1Section } from "../common/components/ctaSection";
import { VideoSection } from "../common/components/videoSection";

export const Home = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: about } = useGetDMaxCommon<AboutDmaxInfoResponse>({ section: "about" });
    const { data: room } = useGetDMaxCommon<RoomDMaxInfoResponse>({ section: "room" });
    const { data: special } = useGetDMaxCommon<SpecialDmaxInfoResponse>({ section: "special" });
    const { data: aside1 } = useGetDMaxCommon<Aside1DmaxInfoResponse>({ section: "aside1" });
    const { data: aside2 } = useGetDMaxCommon<Aside2DmaxInfoResponse>({ section: "aside2" });
    const { data: around } = useGetDMaxCommon<AroundDmaxInfoResponse>({ section: "around" });
    const { data: video } = useGetDMaxCommon<VideoDmaxInfoResponse>({ section: "video" });

    return main && about && room && special && aside1 && aside2 && video ? (
        <>
            <Flex flexDir={video.video_loc === "top" ? "column-reverse" : "column"}>
                <TopSection imgList={main.imgList} sector={main.sector} />
                <VideoSection data={video} />
            </Flex>
            <AboutSection data={about} />
            <RoomPreview data={room} />
            <SpecialPreview data={special} />
            <Aside1Section data={aside1} />
            <Aside2Section data={aside2} />
            {around?.isUse && <Travel data={around} />}
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
